import { DateValue } from '@givebutter/primitives/date-picker';
import { DateTime } from 'luxon';

enum ValidationTextMap {
    Required = 'Required',
    EmptyFilters = 'Please turn on at least one filter.',
    InvalidDate = 'Invalid Date',
}

const validateDate = (date?: DateValue) => {
    if (!date || (Array.isArray(date) && date.some(d => !d))) {
        return 'Invalid Date';
    }

    const normalizedDates: DateTime[] = [];
    Array.isArray(date)
        ? normalizedDates.push(...(date as DateTime[]))
        : normalizedDates.push(date);

    const isInvalid = normalizedDates.some(date => !date.isValid);

    if (isInvalid) {
        return ValidationTextMap.InvalidDate;
    }
};

const zeroSelected =
    (resource: string) =>
    <T>(value?: T[]) => {
        if (value?.length === 0) {
            return `Please select a ${resource}.`;
        }
    };

export { ValidationTextMap, validateDate, zeroSelected };
